var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page error"},[_c('div',{staticClass:"contents-wrapper"},[_vm._m(0),_c('router-link',{staticClass:"button btnLink",attrs:{"to":"/"}},[_vm._v("메인으로 이동")])],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"error-text"},[_vm._v("존재하지 않는 페이지입니다."),_c('br'),_vm._v("\n        메인으로 이동해 주세요.")])
}]

export { render, staticRenderFns }